var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-list-item__status bg-primary text-white",class:{avatar: _vm.isAvatar}},[_c('svg-icon-social',{staticClass:"user-list-item__svg"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }